import { Invoice } from '../../types';

/** Dữ liệu mẫu để test UI (bảng + modal chi tiết) — bật qua REACT_APP_USE_INVOICE_MOCK hoặc mặc định dev */
export const mockInvoices: Invoice[] = [
  {
    id: 1,
    invoice_number: 'INV-2026-001',
    customer_name: 'NGUYỄN THANH VŨ',
    customer_tax_code: '07912345678',
    customer_phone: '0969789789',
    service_name: 'Hóa đơn nước tháng 2/2026',
    total_amount: '133400',
    status: 'sent',
    export_status: 'Đã xuất HĐ',
    import_date: '2026-02-15',
    created_at: '2026-02-15T08:30:00',
    sent_at: '2026-02-15T14:00:00',
    customer_address: '150 Phạm Hùng, Thành phố Hồ Chí Minh',
    customer_code: '512345678',
    household_count: 1,
    water_quota_m3: 20,
    meter_block_reading: 'E045-9078',
    usage_period_start: '2026-01-01',
    usage_period_end: '2026-01-31',
    current_month_reading: 546,
    previous_month_reading: 542,
    consumption_m3: 4,
    consumption_quota_m3: 4,
    unit_price_detail: '29000',
    line_subtotal: '116000',
    subtotal_goods: '116000',
    tax_rate_percent: 5,
    tax_amount: '5800',
    environmental_fee_wastewater_sh_10_percent: '11600',
    amount_in_words: 'Một trăm ba mươi ba nghìn bốn trăm đồng',
    items: [
      {
        description: 'Tiêu thụ nước sinh hoạt (kỳ 01/2026)',
        quantity: 4,
        unit_price: '29000',
        amount: '116000',
      },
    ],
  },
  {
    id: 2,
    invoice_number: 'INV-2026-002',
    customer_name: 'Trần Thị Mai',
    customer_tax_code: '0312345678',
    customer_phone: '0912345678',
    service_name: 'Hóa đơn rác tháng 2/2026',
    total_amount: '172500',
    status: 'draft',
    export_status: undefined,
    import_date: '2026-02-10',
    created_at: '2026-02-10T09:00:00',
    sent_at: null,
    customer_address: '12 Lê Lợi, Quận 1, TP.HCM',
    customer_code: 'KH-8899',
    household_count: 2,
    water_quota_m3: 15,
    meter_block_reading: 'A12-4455',
    usage_period_start: '2026-02-01',
    usage_period_end: '2026-02-28',
    current_month_reading: 120,
    previous_month_reading: 115,
    consumption_m3: 5,
    consumption_quota_m3: 5,
    unit_price_detail: '30000',
    line_subtotal: '150000',
    subtotal_goods: '150000',
    tax_rate_percent: 5,
    tax_amount: '7500',
    environmental_fee_wastewater_sh_10_percent: '15000',
    amount_in_words: 'Một trăm bảy mươi hai nghìn năm trăm đồng',
    items: [
      {
        description: 'Phí dịch vụ thu gom rác sinh hoạt',
        quantity: 5,
        unit_price: '30000',
        amount: '150000',
      },
    ],
  },
  {
    id: 3,
    invoice_number: 'INV-2026-003',
    customer_name: 'Lê Văn Hùng',
    customer_tax_code: '07987654321',
    customer_phone: '0988777666',
    service_name: 'Hóa đơn nước tháng 1/2026',
    total_amount: '89200',
    status: 'sent',
    export_status: 'Đã xuất HĐ',
    import_date: '2026-01-20',
    created_at: '2026-01-20T11:00:00',
    sent_at: '2026-01-21T08:00:00',
    customer_address: '88 Nguyễn Huệ, Quận 1, TP.HCM',
    customer_code: '512999888',
    household_count: 1,
    water_quota_m3: 20,
    meter_block_reading: 'B88-1122',
    usage_period_start: '2025-12-01',
    usage_period_end: '2025-12-31',
    current_month_reading: 88,
    previous_month_reading: 85,
    consumption_m3: 3,
    consumption_quota_m3: 3,
    unit_price_detail: '28000',
    line_subtotal: '84000',
    subtotal_goods: '84000',
    tax_rate_percent: 5,
    tax_amount: '4200',
    environmental_fee_wastewater_sh_10_percent: '1000',
    amount_in_words: 'Tám mươi chín nghìn hai trăm đồng',
    items: [
      {
        description: 'Nước sinh hoạt',
        quantity: 3,
        unit_price: '28000',
        amount: '84000',
      },
    ],
  },
];

function includesInsensitive(hay: string, needle: string): boolean {
  if (!needle) return true;
  return hay.toLowerCase().includes(needle.trim().toLowerCase());
}

function parseYmd(d: string): number {
  const [y, m, day] = d.split('-').map(Number);
  return new Date(y, m - 1, day).getTime();
}

export interface MockInvoiceListParams {
  invoiceNumber?: string;
  patientName?: string;
  service?: string;
  taxCode?: string;
  phone?: string;
  customerName?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
}

export function filterMockInvoices(params: MockInvoiceListParams): {
  data: Invoice[];
  meta: { page: number; pageSize: number; count: number; next: null; previous: null };
} {
  const page = params.page ?? 1;
  const pageSize = params.pageSize ?? 10;

  let list = [...mockInvoices];

  if (params.invoiceNumber) {
    list = list.filter((i) => includesInsensitive(i.invoice_number, params.invoiceNumber!));
  }
  if (params.customerName) {
    list = list.filter((i) => includesInsensitive(i.customer_name, params.customerName!));
  }
  if (params.patientName) {
    list = list.filter((i) => includesInsensitive(i.customer_name, params.patientName!));
  }
  if (params.taxCode) {
    list = list.filter((i) => includesInsensitive(i.customer_tax_code, params.taxCode!));
  }
  if (params.phone) {
    list = list.filter((i) => includesInsensitive(i.customer_phone || '', params.phone!));
  }
  if (params.service) {
    list = list.filter((i) => includesInsensitive(i.service_name, params.service!));
  }

  if (params.startDate || params.endDate) {
    list = list.filter((i) => {
      const raw = i.import_date || i.created_at?.slice(0, 10);
      if (!raw) return false;
      const t = parseYmd(raw);
      if (params.startDate && t < parseYmd(params.startDate)) return false;
      if (params.endDate && t > parseYmd(params.endDate)) return false;
      return true;
    });
  }

  const count = list.length;
  const start = (page - 1) * pageSize;
  const data = list.slice(start, start + pageSize);

  return {
    data,
    meta: {
      page,
      pageSize,
      count,
      next: null,
      previous: null,
    },
  };
}

export function findMockInvoiceById(id: number): Invoice | undefined {
  return mockInvoices.find((i) => i.id === id);
}
